const ASSESSMENT_OPTIONS = [
  { label: 'Aptitude', value: 'aptitude' },
  { label: 'Cognitive', value: 'cognitive' },
  { label: 'Skill', value: 'skill' },
  { label: 'Mega', value: 'mega' },
  { label: 'Extended', value: 'extended' },
  { label: 'EduTech', value: 'edutech' },
  { label: 'Salesforce WorkScore', value: 'salesforce' },
  { label: 'CustomerCare WorkScore', value: 'customercare' },
  { label: 'CallingSales WorkScore', value: 'callingsales' },
  { label: 'FeetOnStreet WorkScore', value: 'feetonstreet' },
  { label: 'Big Five + Productivity', value: 'bigfive_productivity' }
];

const ASSESSMENT_LABEL_TO_KEY = Object.fromEntries(
  ASSESSMENT_OPTIONS.map((option) => [option.label.toLowerCase(), option.value])
);

export { ASSESSMENT_OPTIONS, ASSESSMENT_LABEL_TO_KEY };
